import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";

const ActiveInActiveFilter = ({
  activeInActiveFilterVisible,
  setActiveInActiveFilterVisible,
  sendDataToActiveInActiveFilter,
}) => {
  const roleItems = [
    { name: "ACTIVE", value: true },
    { name: "DEACTIVE", value: false },
  ];

  const [selectedStatus, setSelectedStatus] = useState([]);

  const handleStatusToggle = (status) => {
    setSelectedStatus((prevSelected) => {
      const alreadySelected = prevSelected.some(
        (item) => item.value === status.value
      );

      if (alreadySelected) {
        return prevSelected.filter(
          (item) => item.value !== status.value
        );
      }

      return [...prevSelected, status];
    });
  };

  const handleConfirmFilter = () => {
    const selectedData =
      selectedStatus.length > 0 ? selectedStatus : roleItems;

    sendDataToActiveInActiveFilter(selectedData);

    setActiveInActiveFilterVisible(false);
    setSelectedStatus([]);
  };

  const handleModalClose = () => {
    setActiveInActiveFilterVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={activeInActiveFilterVisible}
        style={{ width: "50vw" }}
        onHide={handleModalClose}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4"
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            {/* Header */}
            <div
              className="flex border-round-xl justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <img
                style={{
                  height: 45,
                  width: 45,
                }}
                src="Laundy_App_Icons_Gifs/Other_Icons/filter.png"
                alt="Filter"
              />

              <p className="text-4xl text-primary-50 font-semibold m-0">
                Select Status
              </p>

              <Button
                label="×"
                onClick={(e) => hide(e)}
                text
                className="text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              />
            </div>

            {/* Status List */}
            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "auto",
              }}
            >
              <div className="mx-4">
                {roleItems.map((item) => {
                  const isSelected = selectedStatus.some(
                    (selected) => selected.value === item.value
                  );

                  return (
                    <div
                      key={String(item.value)}
                      className="flex flex-1 justify-content-between align-items-center my-2"
                    >
                      <p className="text-xl font-medium m-0">
                        {item.name.replace(/_/g, " ")}
                      </p>

                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleStatusToggle(item)}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Filter Button */}
            <Button
              onClick={handleConfirmFilter}
              className="mt-1 mb-3 mx-4 border-round-xl"
            >
              <p className="w-full text-2xl font-semibold flex justify-content-center m-0">
                Filter
              </p>
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default ActiveInActiveFilter;
